/**
 * useSettings
 *
 * UserSettings（認識間隔・差分閾値）の読み書きを扱うフック。
 *
 * 設計上のポイント：
 *   - 初回マウント時に localStorage から読む（無ければ DEFAULT_SETTINGS）
 *   - update() で部分更新（現在値とマージしてから保存）
 *   - storage.ts 経由で読み書き
 */

import { useCallback, useEffect, useState } from 'react';

import * as storage from '../lib/storage';

import type { UserSettings } from '../types';

export interface UseSettingsResult {
  settings: UserSettings;
  /** 設定を部分更新する（現在値とマージしてから保存） */
  update: (patch: Partial<UserSettings>) => void;
}

export function useSettings(): UseSettingsResult {
  const [settings, setSettings] = useState<UserSettings>(storage.DEFAULT_SETTINGS);

  useEffect(() => {
    setSettings(storage.getSettings());
  }, []);

  const update = useCallback((patch: Partial<UserSettings>) => {
    setSettings((current) => {
      const next = { ...current, ...patch };
      storage.saveSettings(next);
      return next;
    });
  }, []);

  return { settings, update };
}
